import {ILandingContentSection} from "@type/models/cms-landing";
import {Device} from "@hooks/useDetectDeviceByMediaQuery";

export type TypeRobotsIndexFollow = 'index,follow' | 'noindex,follow' | 'noindex,nofollow' | null;
export type TypePreloadLink = {
    link: string;
    as?: "image"|"font"|"script"|"style",
    device?: Device | undefined;
}
export interface ISEO {
    __TEMP__FIXME__isPaginated: boolean;
    metaTitle: string;
    metaDescription: string;
    h1_title?: string;
    canonical?: string |"auto";
    shareImage: {
        url: string;
        width: number;
        caption: string;
    };
    preloadImage: {
        url: string;
    };
    preloadImages_USE_THIS_ONLY: TypePreloadLink[],
    robots: TypeRobotsIndexFollow;
    openGraph: {
        title?: string;
        type?: string;
        url?: string;
        image?: string;
        description?: string;
    };
    SyarahAppStores: {
        appleItunesApp: string;
        googlePlayApp: string;
    }
    twitter: {
        card: "summary" | "app";
        site: string;
        title?: string;
        canonical_url?: string;
        image: string;
        description: string;
        appInfo: {
            googlePlay: {
                name: string;
                url: string;
                id: string;
            };
            apple: {
                name: string;
                url: string;
                id: string;
            };
        };
    };
    alternateLanguages: {
        ar?: string;
        en?: string;
        default?: string;
        followCanonical?: boolean;
        withOutHrefs?: boolean;
    };
    structuredData: {
        localBusiness?: string;
        website?: string;
        organization?: string | object;
        BreadcrumbList?: string;
        CarSchema?: string;
        ItemList?: string;
        FAQPage?: string;
        financialService?: string | object;
        Product?: string;
    };
    renderCanonical: boolean;
    forceCanonical: boolean;
}

export type TypeHeading = "h1" | "h2" | "h3"

export type TypeCmsImage = {
    url: string,
    caption: string,
}

export interface ICmsCTA {
    url: string;
    newTab: boolean;
    text: string;
    type: CTAType;
    display_mode: DisplayMode;
}

export interface IStickyMobileCTA {
    url: string;
    newTab: boolean;
    text: string;
    type: CTAType;
}

export type DisplayMode = "all" | "desktop" | "mobile";

export enum CTAType {
    PRIMARY = "primary",
    SECONDARY = "secondary"
}

export enum AlignType {
    CENTER = "center",
    SIDE1 = "side1",
    SIDE2 = "side2"
}


export interface ICardsSlider extends ILandingContentSection {
    cards: ICard[];
    bg_color: string;
    bg_color_mobile: string;
    title: string;
    cta?: ICmsCTA;
}

export interface ICard extends IContentSection {
    title: string
    description?: string
    link?: string
    bg_color?: string
    text_color?: string
    image_loading_behavior: IMAGE_LOADING_BEHAVIOR
    image: TypeCmsImage
}

export interface IBrowseCarsBy extends ILandingContentSection {
    title: string;
    number_of_cars: number;
    cta: ICmsCTA;
    heading: TypeHeading;
}
export interface IBrowseCarsByPriceRange extends ILandingContentSection {
    title: string;
    cta: ICmsCTA;
    heading: TypeHeading;
}
export interface IBrowseCarsByPrices extends ILandingContentSection {
    title: string;
    subtitle:string;
    disclaimer:string;
    cta: ICmsCTA;
    heading: TypeHeading;
    number_of_items_desktop: number;
    number_of_items_mobile: number;
}
export interface ICarPriceSearchSection extends ILandingContentSection {
    title: string;
    subtitle:string;
    heading: TypeHeading;
}
export interface ICarPriceTableSection extends ILandingContentSection {
    title: string;
    heading: TypeHeading;
}

export interface IFinancingCalculator extends ILandingContentSection {
    initial_price: number;
    title: string;
}

export interface IBulletedList extends ILandingContentSection {
    title: string;
    list_items: string;
    icon: TypeCmsImage;
}

export interface IBulletedListCards extends ILandingContentSection {
    lists: IBulletedList[];
}

export interface IBanksGroup extends ILandingContentSection {
    title: string;
    cta: ICmsCTA;
    banks: { name: string; logo: { url: string, caption: string } }[];
}

export interface ITwoColumnsList extends IContentSection {
    lists: IBulletedList[];
}

export type IMAGE_LOADING_BEHAVIOR = "eager" | "lazy"


export enum ComponentType {
    HERO = "sections.hero",
    HEADER_PANEL = "layout.header-panel-aligned-left",
    FINANCE_DETAILS = "react-custom-components.finance-details-table",
    BROWSE_CARS = "sections.browse-cars-by",
    BENEFITS_LIST = "sections.benefits-list",
    BROWSE_FINANCING = "sections.browse-financing-make-model-year",
    BROWSE_CARS_BY_YEARS = "react-custom-components.browse-cars-by-years",
    PROCESS_STEPS = "sections.process-steps",
    TWO_COLUMNS_LIST = "react-custom-components.two-columns-bulleted-list",
    BANKS_GROUP = "sections.banks-group",
    ABOUT_SYARAH = "sections.about-syarah",
    NEED_HELP = "react-custom-components.do-you-need-help",
    FULL_BANKS_LIST = "react-custom-components.full-banks-list",
    BREADCRUMB = "layout.breadcrumb",
    BUTTON_LINK = "links.button-link",

}


export interface IContentSection {
    __component: ComponentType;
}
